import React, { CSSProperties, PropsWithChildren, useEffect } from "react";

type BreadcrumbItem = {
  title: string;
  url: string;
};

type EasesPageTemplateWrapperProps = PropsWithChildren<{
  cardClass?: string | undefined;
  cardStyle?: CSSProperties;
  breadcrumb?: Array<string | BreadcrumbItem> | undefined;
  title?: string | undefined;
  optionsSegment?: Function | undefined;
}>;

// eslint-disable-next-line no-unused-vars
export default function EasasPageTemplateWrapper(props: EasesPageTemplateWrapperProps) {
  useEffect(() => {
    if (props.title) {
      document.title = `DWEEN: ${props.title}`;
    }
  }, [props.title]);

  const breadcrumbEmpty = props.breadcrumb == null || props.breadcrumb.length === 0;

  return (
    <>
      {/* === Bread crumb and options segment rendering  === */}
      {props.optionsSegment != null ||
        (!breadcrumbEmpty && (
          <div className="layout-breadcrumb" style={{ paddingBottom: "12px" }}>
            <div className="breadcrumb">
              <div className="route-bar-breadcrumb">
                {!breadcrumbEmpty &&
                  props.breadcrumb?.map((item, idx) => {
                    let crumb;
                    let itemName: string;
                    if (typeof item === "string") {
                      itemName = item;
                      crumb = <span>{item.toUpperCase()}</span>;
                    } else {
                      const bcItem = item as BreadcrumbItem;
                      itemName = bcItem.title;
                      crumb = (
                        <a href={bcItem.url} style={{ fontWeight: 600 }}>
                          {bcItem.title.toUpperCase()}
                        </a>
                      );
                    }

                    return (
                      <React.Fragment key={`${itemName}`}>
                        {crumb}
                        {idx < props.breadcrumb!!.length - 1 && (
                          <li style={{ paddingLeft: "1rem" }}>
                            <i className="pi pi-chevron-right" />
                          </li>
                        )}
                      </React.Fragment>
                    );
                  })}
              </div>
            </div>

            <div className="options-segment">{props.optionsSegment}</div>
          </div>
        ))}

      <div className={`card ${props.cardClass ? props.cardClass : ""}`} style={props.cardStyle}>
        {props.children}
      </div>
    </>
  );
}
